import { Paper, Tab, Tabs } from "@mui/material";

const AssetTabs = ({assetCount,filter,onChangeTab,activeCount}) => {
    console.log("assetCount?.hpt",assetCount?.hpt)
    const assetCounts = Object.values(assetCount || {}).filter(item => typeof item === "number");
    const totalCount = assetCounts.reduce((total, count) => total + count, 0);
    const isSingleAssetType = totalCount > 0 && assetCounts.some(item => item === totalCount)
    const typeValueByKey = { aircraft: 1, engine: 2, propeller: 5, lg: 4, apu: 3, fan: 6, hpt: 7, hpc: 8, lpt: 9 };
    // When only one asset type exists at all, its tab is the only one shown (ALL is hidden) — so a
    // filter applied with no explicit asset_type (e.g. just the Asset dropdown) still needs the
    // override routed to that sole tab instead of the invisible "ALL" tab (value 0).
    const soleTypeValue = isSingleAssetType
        ? typeValueByKey[Object.keys(assetCount || {}).find(key => assetCount[key] === totalCount && typeValueByKey[key])]
        : null;
    const activeAssetType = filter?.asset_type || soleTypeValue || 0;
    // activeCount overrides the selected tab's number when the base breakdown can't express the
    // applied filter (aircraft/engine type drill-down, or specific assets picked in the Asset dropdown).
    const countFor = (typeValue, baseCount) => (activeAssetType === typeValue && activeCount != null) ? activeCount : baseCount;

    return (
        <Paper elevation={0} className="lease-module-paper" style={{ marginBottom: '10px' }}>
            <Tabs value={filter?.asset_type} onChange={onChangeTab} variant="fullWidth">
                {isSingleAssetType ? null : <Tab label={`ALL (${countFor(0, totalCount) || 0})`} value={0} />}
                {assetCount?.aircraft > 0 && <Tab label={`Aircraft (${countFor(1, assetCount?.aircraft) || 0})`} value={1} />}
                {assetCount?.engine > 0 && <Tab label={`Engine (${countFor(2, assetCount?.engine) || 0})`} value={2} />}
                {assetCount?.propeller > 0 && <Tab label={`Propeller (${countFor(5, assetCount?.propeller) || 0})`} value={5} />}
                {assetCount?.lg > 0 && <Tab label={`Landing Gear (${countFor(4, assetCount?.lg) || 0})`} value={4} />}
                {assetCount?.apu > 0 && <Tab label={`APU (${countFor(3, assetCount?.apu) || 0})`} value={3} />}
                {assetCount?.fan > 0 && <Tab label={`FAN (${countFor(6, assetCount?.fan) || 0})`} value={6} />}
                {assetCount?.hpt > 0 && <Tab label={`HPT (${countFor(8, assetCount?.hpt) || 0})`} value={8} />}
                {assetCount?.hpc > 0 && <Tab label={`HPC (${countFor(7, assetCount?.hpc) || 0})`}  value={7}/>}
                {assetCount?.lpt > 0 && <Tab label={`LPT (${countFor(9, assetCount?.lpt) || 0})`} value={9} />}
            </Tabs>
        </Paper>
    )
}
export default AssetTabs;
